import PropTypes from 'prop-types';
import React from 'react';

import { Avatar, Button, Menu, MenuItem, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

const UserProfileMenu = ({ user, anchorEl, handleMenuClose, handleMenuClick }) => (
  <>
    <Button onClick={handleMenuClick} startIcon={<Avatar src={user.picture} />} sx={{ textTransform: 'none' }}>
      <Grid container direction="column" sx={{ display: { xs: 'none', sm: 'flex' } }}>
        <Typography variant="body1" className="avatar-data">
          {user.name}
        </Typography>
        <Typography variant="body2" className="avatar-data-detail">
          {user.correspondent_name}
        </Typography>
      </Grid>
    </Button>
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      slotProps={{
        paper: {
          elevation: 3,
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}>
      <MenuItem onClick={() => console.log('Go to profile')}>Mi perfil</MenuItem>
      <MenuItem onClick={() => console.log('Log out')}>Cerrar sesión</MenuItem>
    </Menu>
  </>
);

UserProfileMenu.propTypes = {
  user: PropTypes.any,
  anchorEl: PropTypes.element.isRequired,
  handleMenuClose: PropTypes.func.isRequired,
  handleMenuClick: PropTypes.func.isRequired,
};

export default UserProfileMenu;
